// ReSharper disable UnusedParameter
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("mainMenu", {
        templateUrl: "app/admin/mainmenu.component.html",
        controller: ["menuService", "authService", "frameworkService", "$localStorage", "$location", "$scope", "$state", "$rootScope", "$sessionStorage", "$transitions", "$uibModal", "_", MainMenuCtrl],
        controllerAs: "vm"
    });
    function MainMenuCtrl(menuService, authService, frameworkService, $localStorage, $location, $scope, $state, $rootScope, $sessionStorage, $transitions, $uibModal, _) {
        var vm = this;
        vm.state = $state.current.name;
        vm.url = $location.$$url;
        vm.frameworkData = frameworkService.data;
        vm.userDetails = authService.authentication;
        vm.menu = null;
        //
        vm.openContactUsModal = openContactUsModal;
        //vm.toggleMenu = toggleMenu; //2024-04-12 remove minified version of menu
        //
        $scope.$on("reloadMenu", function () {
            loadMenu();
        });
        $rootScope.$on("toggleMenu", function (_scope, value) {
            if (value !== undefined) {
                vm.frameworkData.slideAdmin = value;
            }
            else {
                vm.frameworkData.slideAdmin = !vm.frameworkData.slideAdmin;
            }
        });
        $rootScope.$on("setAdminMenuVisible", function (_scope, value) {
            if (value !== undefined) {
                vm.frameworkData.showAdmin = value;
            }
        });
        $transitions.onSuccess({}, function (trans) {
            vm.url = $location.$$url;
            vm.state = trans.$to().self.name;
            //console.log(vm.state, vm.url);
            selectMenu();
        });
        loadMenu();
        ///////////////////////////////////////////////////////////////////////
        function loadMenu() {
            vm.dataLoaded = false;
            vm.showMenu = false;
            menuService.getMenu().then(function (data) {
                vm.allMenu = angular.copy(data);
                //vm.subMenus = _.flatten(_.map(data, (item) => {
                //	return { menuRoute: item.route, subMenus: item.subMenus };
                //}));
                vm.accountMenu = _.filter(vm.allMenu, function (item) {
                    return item.order < 10;
                });
                vm.menu = _.filter(vm.allMenu, function (item) {
                    return item.order >= 10;
                });
                //menuRoute is the top level route (dashboard, learning plan, account, people, learning items, eveluations, etc)
                //subMenuRoute is for sub menu routes (my account, my badges, inventory, etc)
                vm.flatMenu = [];
                _.each(data, function (item) {
                    if (item.subMenus) {
                        _.each(item.subMenus, function (subMenu) {
                            subMenu.menuRoute = item.route || item.url;
                            subMenu.subMenuRoute = subMenu.route || subMenu.url;
                            vm.flatMenu.push(subMenu);
                        });
                        delete item.subMenus;
                    }
                    item.menuRoute = item.route || item.url;
                    vm.flatMenu.push(item);
                });
                vm.version = $sessionStorage.version;
                vm.dataLoaded = true;
                vm.showMenu = true;
                //console.log(vm.flatMenu);
                selectMenu();
                vm.pages = _.filter(angular.copy(vm.frameworkData.tenant.pages), function (page) {
                    if (page.url.toLowerCase().includes("siteadmin")) {
                        if (!authService.isSiteAdmin())
                            return false;
                    }
                    if (page.url.toLowerCase().includes("superadmin")) {
                        if (!authService.isSuperAdmin())
                            return false;
                    }
                    return page.localizationId === $localStorage.currentLocalizationId;
                });
            });
        }
        function openContactUsModal() {
            vm.openMenu = '';
            //$uibModal.open({
            //	templateUrl: "app/public/contactUsView.html",
            //	controller: "ContactUsCtrl as vm",
            //	scope: $scope,
            //	backdrop: "static",
            //	resolve: {
            //		userInfo: function () {
            //			return {
            //				firstName: vm.userDetails.userFirstName,
            //				lastName: vm.userDetails.userLastName,
            //				email: vm.userDetails.userEmail,
            //				tenantId: vm.frameworkData.tenant.id,
            //				regNumber: vm.userDetails.userPersonSeq
            //			};
            //		}
            //	}
            //}).result.catch(angular.noop);
            var data = {
                firstName: vm.userDetails.userFirstName,
                lastName: vm.userDetails.userLastName,
                email: vm.userDetails.userEmail,
                tenantId: vm.frameworkData.tenant.id,
                regNumber: vm.userDetails.userPersonSeq
            };
            $rootScope.$broadcast("openContactUs", data);
        }
        function selectMenu() {
            //var menu = _.filter(vm.allMenu, function (item) {
            //	return _.some(item.subMenus, function (subItem) {
            //		return vm.activeMenu.includes(subItem.route) || vm.url.includes(subItem.url);
            //	});
            //});
            //if (menu.length > 0)
            //	vm.activeRoute = menu[0].route;
            //else
            //	vm.activeRoute = vm.activeMenu;
            //
            //find exact match
            var menuitem = _.find(vm.flatMenu, function (item) {
                return vm.state === item.route || vm.url === item.url;
            });
            //not exact matches
            //if (!menuitem) {
            //	menuitem = _.find(vm.flatMenu, (item) => {
            //		return vm.state.includes(item.route) && item.subMenuRoute;
            //	});
            //}
            //if (menuitem)
            //	alert('menuitem == true');
            //if (!menuitem) {
            //	menuitem = _.find(vm.flatMenu, (item) => {
            //		return vm.url.includes(item.url) && item.subMenuRoute;
            //	});
            //}
            //if (menuitem)
            //	alert('menuitem == true');
            if (!menuitem) {
                menuitem = _.find(vm.flatMenu, function (item) {
                    return vm.state.includes(item.route);
                });
            }
            if (!menuitem) {
                menuitem = _.find(vm.flatMenu, function (item) {
                    return vm.url.includes(item.url);
                });
            }
            vm.menuRoute = menuitem === null || menuitem === void 0 ? void 0 : menuitem.menuRoute; // ?? vm.menuRoute;
            vm.route = menuitem === null || menuitem === void 0 ? void 0 : menuitem.subMenuRoute; // ?? vm.route;
            //console.log(vm.menuRoute, vm.route);
            ////find best match via route and url - I think we can include menu selection in every component for better results
            //var routeMenuitem = _.find(vm.flatMenu, (item) => {
            //	return vm.state.includes(item.route) && item.subMenuRoute;
            //});
            //var urlMenuitem = _.find(vm.flatMenu, (item) => {
            //	return vm.url.includes(item.url) && item.subMenuRoute;
            //});
            //var routeMenuLength = routeMenuitem?.route.length ?? 0;
            //var urlMenuLength = urlMenuitem?.route.length ?? 0;
            //if (routeMenuLength > urlMenuLength) {
            //	vm.menuRoute = routeMenuitem?.menuRoute ?? "";
            //	vm.route = (routeMenuitem?.route || routeMenuitem?.url) ?? "";
            //} else {
            //	vm.menuRoute = urlMenuitem?.menuRoute ?? "";
            //	vm.route = (urlMenuitem?.route || urlMenuitem?.url) ?? "";
            //}
        }
        //2024-04-12 remove minified version of menu
        //function toggleMenu() {
        //	$rootScope.$broadcast("ContentSizeChanged");
        //	vm.frameworkData.minify = !vm.frameworkData.minify;
        //};
    }
})();
